export const POSTAL_CODE_ERROR = Object.freeze({
  REQUIRED: "required",
  FORMAT: "format",
  NOT_ARIZONA: "not_arizona",
});

const POSTAL_CODE_PATTERN = /^[0-9]{5}(?:-[0-9]{4})?$/;

// This frontend heuristic is optimistic; the backend enforces the rule.
// It is not an assigned-code list or derived from Census/ZCTA map data; a
// USPS-backed allowlist remains potential future work.
const ARIZONA_ZIP_PREFIX_MIN = 850;
const ARIZONA_ZIP_PREFIX_MAX = 865;

export function sanitizeReportPostalCodeInput(value) {
  return String(value || "").replace(/[^0-9]/g, "").slice(0, 5);
}

export function sanitizeReportPostalCodeEdit(value, selectionStart, selectionEnd = selectionStart) {
  const rawValue = String(value || "");
  const sanitizedValue = sanitizeReportPostalCodeInput(rawValue);
  const sanitizePosition = (position) => sanitizeReportPostalCodeInput(
    rawValue.slice(0, Math.max(0, Number(position) || 0))
  ).length;

  return {
    value: sanitizedValue,
    selectionStart: sanitizePosition(selectionStart),
    selectionEnd: sanitizePosition(selectionEnd),
  };
}

export function validateArizonaPostalCode(value) {
  const postalCode = String(value || "").trim();
  if (!postalCode) return { ok: false, error: POSTAL_CODE_ERROR.REQUIRED };
  if (!POSTAL_CODE_PATTERN.test(postalCode)) {
    return { ok: false, error: POSTAL_CODE_ERROR.FORMAT };
  }
  const normalized = postalCode.slice(0, 5);
  if (!isArizonaPostalCode(normalized)) {
    return { ok: false, error: POSTAL_CODE_ERROR.NOT_ARIZONA };
  }
  return { ok: true, value: normalized };
}

export function isArizonaPostalCode(postalCode) {
  const prefix = Number(String(postalCode).slice(0, 3));
  return prefix >= ARIZONA_ZIP_PREFIX_MIN && prefix <= ARIZONA_ZIP_PREFIX_MAX;
}
